import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { Promotion } from '@app/shared/models/promotion';
import { isPlatformBrowser } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class PromotionService {

  headers = new HttpHeaders().set('Authorization', 'true');

  constructor(private readonly http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: any) { }

  // root context
  getPromotion(id: string): Observable<{ promotion: Promotion }> {
    return this.http.get<{ promotion: Promotion }>('service:promotion' + '/promotion/' + id, { headers: this.headers });
  }

  loadPromotionByUrl(url: string): Observable<{ promotion: Promotion }> {
    return this.http.get<{ promotion: Promotion }>(url, { headers: this.headers });
  }

  // team context
  getTeamPromotion(teamId, promotionId): Observable<{ promotion: Promotion }> {
    return this.http.get<{ promotion: Promotion }>('service:promotion' + '/team/' + teamId + '/promotion/' + promotionId, { headers: this.headers });
  }

  listTeamPromotions(teamId): Observable<{ promotions: Promotion[] }> {
    return this.http.get<{ promotions: Promotion[] }>('service:promotion' + '/team/' + teamId + '/promotions', { headers: this.headers });
  }

  // managed context
  getManagedPromotion(id): Observable<{ promotion: Promotion }> {
    return this.http.get<{ promotion: Promotion }>('service:promotion' + '/managedPromotion/' + id, { headers: this.headers });
  }

  listManagedPromotions(): Observable<{ promotions: Promotion[] }> {
    return this.http.get<{ promotions: Promotion[] }>('service:promotion' + '/managedPromotions/external', { headers: this.headers });
  }

  listManagedPromotionsInternal(): Observable<{ promotions: Promotion[] }> {
    return this.http.get<{ promotions: Promotion[] }>('service:promotion' + '/managedPromotions/internal', { headers: this.headers });
  }


  listPromotions(teamId): Observable<{ promotions: Promotion[] }> {
    return this.http.get<{ promotions: Promotion[] }>('service:promotion' + '/team/' + teamId + '/promotions/external', { headers: this.headers });
  }

  listPromotionsInternal(teamId): Observable<{ promotions: Promotion[] }> {
    return this.http.get<{ promotions: Promotion[] }>('service:promotion' + '/team/' + teamId + '/promotions/internal', { headers: this.headers });
  }

  createPromotion(teamId, promotion): Observable<any> {
    return this.http.post<any>('service:promotion' + '/team/' + teamId + '/promotion', promotion, { headers: this.headers });
  }

  updatePromotion(id, params): Observable<any> {
    return this.http.put<any>('service:promotion' + '/promotion/' + id, params, { headers: this.headers });
  }

  updateTeamPromotion(teamId, promotionId, params): Observable<any> {
    return this.http.put<any>('service:promotion' + '/team/' + teamId + '/promotion/' + promotionId, params, { headers: this.headers });
  }

  addMediasToPromotion(teamId, promotionId, media): Observable<any> {
    const mediaTuPush = { ...media };
    if (media.sourceUrl) mediaTuPush.url = media.sourceUrl;
    return this.http.post<any>('service:promotion' + '/team/' + teamId + '/promotion/' + promotionId + '/media', mediaTuPush, { headers: this.headers });
  }

  removeMediaToPromotion(teamId, promotionId, mediaId): Observable<any> {
    return this.http.delete<any>('service:promotion' + '/team/' + teamId + '/promotion/' + promotionId + '/media/' + mediaId, { headers: this.headers });
  }

  uploadImage(url: string, body: any) {
    const req = new HttpRequest('PUT', url, body, {
      reportProgress: false
    });
    return this.http.request(req);
  }

  sendPromotionStat(data): Observable<any> {
    return this.http.post<any>('service:promotionstats', data, { headers: this.headers });
  }

  clickPromotion(promotion, media) {
    const data = {
      promotion: promotion.id,
      media: media.id,
      media_type: media.type,
      type: 'Click',
      name: promotion.name
    };
    return this.sendPromotionStat(data);
  }

  viewPromotion(promotion, media) {
    const data = {
      promotion: promotion.id,
      media: media.id,
      media_type: media.type,
      type: 'View',
      name: promotion.name
    };
    return this.sendPromotionStat(data);
  }

  deletePromotion(teamId, promotionId) {
    return this.http.delete<any>('service:promotion' + '/team/' + teamId + '/promotion/' + promotionId, { headers: this.headers });
  }

  enablePromotion(teamId, promotionId) {
    // disable promotion
    return this.http.put<any>('service:promotion' + '/team/' + teamId + '/promotion/' + promotionId, { status: "Enabled" }, { headers: this.headers });
  }

  getThumbnailVimeo(id): Observable<any[]> {
    const vimeoHeaders = new HttpHeaders({});
    // vimeoHeaders.delete('Content-Type');
    // vimeoHeaders.delete('content-type');
    vimeoHeaders.delete('Content-Type', 'application/json')
    // proxied request
    return this.http.get<any>('https://vimeo.com/api/v2/video/' + id + '.json', { headers: vimeoHeaders });
    // return this.http.get<any[]>('/api/oembed.json?url=' + id , {headers : vimeoHeaders});
  }
}
